// extracted by mini-css-extract-plugin
module.exports = {"root":"SuccessAlert_root__uG1x1"};